import FormHelperText from "@mui/material/FormHelperText";
import { FieldMetaProps } from "formik";

export interface IFieldError {
  meta: Partial<FieldMetaProps<any>>;
}

/**
 * Field Error Component.
 * @param props - meta object passed in manually or from formik.
 */
export const FieldError = (props: IFieldError): JSX.Element => {
  const { meta } = props;
  return meta?.error && typeof meta?.error === "string" && meta?.error !== "" ? (
    <FormHelperText classes={{ root: "error-message" }}>{meta.error}</FormHelperText>
  ) : null;
};
